export const BASE_URL = process.env.REACT_APP_BASE_URL
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY || ''
export const APP_NAME = '@dls'
